module.exports = __webpack_public_path__ + "img/e401234.jpg";